// @flow
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
const validationSchemaAddressFragment = `
 fragment ValidationSchemaAddress on SchemaValidationFieldInterface {
  name
  ...on ValidationSchemaObjectField {
    fields {
      name
      required
      validators {
        name
        value
      }
    }
  }
 }
`;
export default validationSchemaAddressFragment;
